import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AppVersion } from '../interfaces/appVersion';

@Injectable({
  providedIn: 'root'
})
export class AppVersionService {
  private apiUrl = environment.apiUrl + 'version';

  constructor(private http: HttpClient) {}

  getVersion(): Observable<AppVersion> {
    return this.http.get<AppVersion>(this.apiUrl).pipe(
      catchError((error) => {
        console.error('Error fetching version:', error);
        return throwError(() => new Error('Failed to fetch version'));
      })
    );
  }

  incrementVersion(): Observable<AppVersion> {
    return this.http.post<AppVersion>(`${this.apiUrl}/increment`, {}).pipe(
      catchError((error) => {
        console.error('Error incrementing version:', error);
        return throwError(() => new Error('Failed to increment version'));
      })
    );
  }

  setVersion(version: string): Observable<AppVersion> {
    return this.http.post<AppVersion>(`${this.apiUrl}/set`, { version }).pipe(
      catchError((error) => {
        console.error('Error setting version:', error);
        return throwError(() => new Error('Failed to set version'));
      })
    );
  }
}
